import { createSelector, Selector } from '@reduxjs/toolkit'
import moment from 'moment'
import { GlobalState } from 'store'
import { timeStoreSelector } from './storeSelectors'

export const serverClientTimeOffsetSelector: Selector<GlobalState, number> = createSelector(timeStoreSelector, timeStore => {
  if (timeStore.server === '' || timeStore.client === '') {
    return 0
  } else {
    return moment(timeStore.client).diff(timeStore.server)
  }
})
